import { trackInfoCardImpression } from "./event/trackInfoCardImpression";
import { trackOpenMenu } from "./event/trackOpenMenu";
import { trackPageLeave } from "./event/trackPageLeave";
import { trackPremiumInformationBoxImpression } from "./event/trackPremiumInformationBoxImpression";
import { trackSalesPosterImpression } from "./event/trackSalesPosterImpression";
import { trackSubscriptionClick } from "./event/trackSubscriptionClick";
import { trackUrlResourceClick } from "./event/trackUrlResourceClick";
import { trackTeaserClick } from "./event/trackTeaserClick";
import { trackInfoCardClick } from "./event/trackInfoCardClick";
import { trackTeaserImpression } from "./event/trackTeaserImpression";
import { trackViewArticle } from "./event/trackViewArticle";
import { trackViewFrontpage } from "./event/trackViewFrontpage";
import { trackViewNewsMixPage } from "./event/trackViewNewsMixPage";
import { trackViewSJPartnerPage } from "./event/trackViewSJPartnerPage";
import { trackViewStrawberryPartnerPage } from "./event/trackViewStrawberryPartnerPage";
import { isStorybookRuntime } from "../utils/isStorybookRuntime";

const noop = (..._args: unknown[]) => {};

const usePulse = () => {
  if (isStorybookRuntime()) {
    return {
      trackOpenMenu: noop,
      trackViewArticle: noop,
      trackViewFrontpage: noop,
      trackViewNewsMixPage: noop,
      trackViewSJPartnerPage: noop,
      trackViewStrawberryPartnerPage: noop,
      trackTeaserClick: noop,
      trackInfoCardClick: noop,
      trackTeaserImpression: noop,
      trackPremiumInformationBoxImpression: noop,
      trackSalesPosterImpression: noop,
      trackSubscriptionClick: noop,
      trackUrlResourceClick: noop,
      trackPageLeave: noop,
      trackInfoCardImpression: noop,
    };
  }

  return {
    trackOpenMenu,
    trackViewArticle,
    trackViewFrontpage,
    trackViewNewsMixPage,
    trackViewSJPartnerPage,
    trackViewStrawberryPartnerPage,
    trackTeaserClick,
    trackInfoCardClick,
    trackTeaserImpression,
    trackPremiumInformationBoxImpression,
    trackSalesPosterImpression,
    trackSubscriptionClick,
    trackUrlResourceClick,
    trackPageLeave,
    trackInfoCardImpression,
  };
};

export { usePulse };
